import React from 'react';
import MolduraJuridica from '../components/juridico/MolduraJuridica';
import { TERMOS } from '../juridico/termos';

/* Termos de Serviço no desenho novo; os antigos (TermsOfService.js) voltam trocando o import em App.js. */
const NewTermsOfService = ({ user }) => (
  <MolduraJuridica user={user} doc={TERMOS} irmao={{ caminho: '/privacy-policy', nome: 'site.privacidade' }} />
);

export default NewTermsOfService;
